<div class="bucket-selector inline-flex min-w-0 max-w-full items-center gap-1.5" [attr.data-state]="state">
  <!-- In a row the combobox keeps its fixed width while there is room, and only gives up
       width on narrow phones so the accept check still fits beside it. -->
  <div
    class="bucket-selector-combobox relative min-w-0 transition"
    [class.inline-flex]="!fillWidth()"
    [class.shrink-0]="!fillWidth()"
    [class.flex]="fillWidth()"
    [class.w-transaction-row-bucket]="fillWidth()"
    [class.max-w-full]="fillWidth()"
  >
    <app-ui-combobox
      placeholder="Add budget"
      searchPlaceholder="Search budgets"
      emptyText="No budgets found."
      data-testid="transaction-budget-combobox"
      headerActionLabel="+ Add new budget"
      appearance="outline"
      [indicatorIcon]="state === 'suggested' ? 'lucideSparkles' : null"
      [suggested]="state === 'suggested'"
      [size]="size()"
      [fillWidth]="fillWidth()"
      [width]="fillWidth() ? '100%' : (width() ?? 'var(--app-size-bucket-selector-min-width)')"
      [options]="bucketOptions()"
      [suggestedOptions]="suggestedBucketOptions()"
      [value]="selectedBucketOption()"
      [(open)]="menuOpen"
      (valueChange)="onBucketOptionChange($event)"
      (headerAction)="openAddBudgetDialog()"
    />
  </div>

  @if (hasSelectedUnsavedBucket()) {
    <button
      appUiButton
      type="button"
      appearance="solid"
      tone="accent"
      class="bucket-selector-save shrink-0 self-center leading-none [&_app-ui-icon]:h-3.5 [&_app-ui-icon]:w-3.5"
      [class.rounded-full]="size() === 'compact'"
      [class.p-0]="size() === 'compact'"
      [size]="size()"
      iconOnly
      data-testid="transaction-budget-save"
      [attr.aria-label]="state === 'suggested' ? 'Accept suggested budget' : 'Save budget'"
      [title]="state === 'suggested' ? 'Accept suggestion' : 'Save'"
      (click)="onSave($event)"
    >
      <app-ui-icon name="check" class="h-3.5 w-3.5" />
      <span class="sr-only">{{ state === 'suggested' ? 'Accept suggestion' : 'Save bucket' }}</span>
    </button>
  }
</div>
